import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initAppSentry } from '@gjl/sentry/app'
import App from './App'
import './globals.css'

// Error reporting, before the first render so a crash in the initial tree is
// reported rather than silently blanking the page. This is a paying client's
// site with no server in the page path: a React crash serves HTTP 200 and the
// rate(5 minutes) site monitor reports UP, so nothing contradicts it.
// See docs/pm/active/frontend-error-reporting.md §1.
initAppSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_APP_VERSION,
  tags: { site: 'sierra-canyon-photo' },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
)
